import React, {Component} from 'react';
import {compose} from "redux";
import {withRouter} from "react-router-dom";
import {withFirestore, firestoreConnect, populate, useFirestoreConnect} from "react-redux-firebase";
import {connect} from "react-redux";
import {UserIsAuthenticated} from "../../utils/AuthManager";
import {StyledButton} from "../../components/Buttons";
import {CALL_DB_PATH, COMPANY_DB_PATH} from "../../constants/DB_PATHS";
import {BackgroundDiv} from "../../components/Containers";
import Navbar from "../../components/Navbar";
import CallListItem from "../../components/CallListItem";
import withCompanyManagerHOC from "../../components/auth/CompanyManagerHOC";
import withMyCoordsHOC from "../../components/MyCoordsHOC";
import ActiveCalls from "./ActiveCalls";
import ActiveCallsList from "../../components/ListQueries/ActiveCallsList";
import FinishedCallsList from "../../components/ListQueries/FinishedCallsList";
import CallsByEmployeeList from "../../components/ListQueries/CallsByEmployeeList";
import EmployeeList from "../../components/EmployeeList";
import {setCompanyCallsView, setSelectedEmployee} from "../../redux/uxEnhance/action";
import QueryOptions from "../../components/TableQueries/QueryOptions";

class CompanyCalls extends Component {
    constructor() {
        super();
        this.state = {
            queryList: 'ready',
        }
    }

    render() {
        console.log(this.props)
        console.log(this.state)
        return (
            <div>
                <BackgroundDiv/>
                <h2>My company calls</h2>
                <div style={{paddingBottom: '5rem', paddingTop: '5rem'}}>

                    <QueryOptions/>

                    {/*
                        Due to the population, the queried data form has changed.
                        Data modification was necessary.
                        Expected data form by CallListItem:
                        0: {
                        id: ...
                        ... data
                        }
                        The data form in this case:
                        id: {
                        ... data
                        }
                        (Id excluded from the object, now it is the index)
                        */}


                    <h3 onClick={()=>{
                        this.props.setCompanyCallsView('active')
                    }}>Active Calls</h3>
                    {this.props.companyCallsView === 'active' ?
                        <ActiveCallsList/>
                        :
                        null
                    }

                    <h3 onClick={()=>{
                        this.props.setCompanyCallsView('ready')
                    }}>Ready Calls</h3>
                    {this.props.companyCallsView === 'ready' ?
                        <FinishedCallsList/>
                        :
                        null
                    }
                    <h3 onClick={() => {
                        this.props.setCompanyCallsView('employee')
                    }}>Employee Calls</h3>
                    {this.props.companyCallsView === 'employee' ?
                        <div>
                            <EmployeeList/>
                            {/*<div>selected: {this.state.selectedEmp}</div>
                            <div>
                                {this.props.empList && this.props.empList !== 0 ?
                                    <ul>
                                        {Object.entries(this.props.empList).map((e, i) => {
                                            const user = e[1].employeeId
                                            return (
                                                <li key={i} onClick={() => {
                                                    this.setState({selectedEmp: user.id})
                                                }}>
                                                    <span>{user.firstN} {user.lastN} {e[1].status}</span>
                                                </li>
                                            )
                                        })}
                                    </ul>
                                    :
                                    <div>No employees</div>
                                }
                            </div>*/}
                            {this.props.selectedEmp ?
                                <CallsByEmployeeList
                                    empId={this.props.selectedEmp.id}
                                    takenBy={{
                                        firstN: this.props.selectedEmp.firstN,
                                        lastN: this.props.selectedEmp.lastN,
                                    }}
                                />
                                :
                                <div>Please select employee</div>
                            }
                        </div>
                        :
                        null

                    }


                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return{
        selectedEmp: state.uxEnhance.selectedEmp,
        companyCallsView: state.uxEnhance.companyCallsView
    }
}

const mapDispatchToProps = dispatch => {
    return{
        setCompanyCallsView: (view) => dispatch(setCompanyCallsView(view))
    }
}
export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withRouter,
    withFirestore,
    connect(
        ({firebase: {auth, profile}}) => ({
            auth,
            profile,
        })
    ),
    UserIsAuthenticated,
    withCompanyManagerHOC,
    withMyCoordsHOC,

)(CompanyCalls);